/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  About / Photographer data
  ============================================================

  Sama data palvelee sekä etusivun AboutSectionia että
  varsinaista AboutPagea.

  Tulevaisuudessa rakenne voidaan korvata WordPress REST API
  -vastauksella ilman layoutin uudelleenrakentamista.

  HUOM:
  Sivun tekstit ovat kehitysvaiheen esimerkkisisältöä.
  Asiakkaan lopullinen henkilökohtainen sisältö lisätään myöhemmin.
*/

const aboutData = {
  image:
    "/media/about/photographer.webp",

  imagePosition:
    "50% 50%",

  page: {
    hero: {
      eyebrow: {
        fi: "Kuvaaja · Kuvien takana",
        en: "Photographer · Behind the images",
      },

      title: {
        fi: "Ensin ihminen. Sitten kuva.",
        en: "People first. Photographs second.",
      },

      description: {
        fi:
          "Kamera on työväline. Tärkeämpää on nähdä ihminen sen edessä ja rakentaa tilanne, jossa kuva voi syntyä ilman kiirettä tai suorittamista.",
        en:
          "The camera is a tool. What matters more is seeing the person in front of it and creating enough space for a photograph to happen without pressure or performance.",
      },
    },

    portrait: {
      eyebrow: {
        fi: "Tapa katsoa",
        en: "A way of seeing",
      },

      title: {
        fi:
          "Kuvassa saa olla hiljaa, liikkua, nauraa tai unohtaa kameran.",
        en:
          "You can be quiet, move, laugh or forget about the camera entirely.",
      },

      text: {
        fi:
          "Hyvä kuvaustilanne ei tunnu valmiiksi kirjoitetulta. Ohjausta on silloin kun sitä tarvitaan, mutta kaikkea ei tarvitse rakentaa kameralle.",
        en:
          "A good session does not feel scripted. There is guidance when it helps, but not everything needs to be constructed for the camera.",
      },

      textTwo: {
        fi:
          "Tavoitteena on tehdä tilaa eleille, katseille ja pienille hetkille, jotka muuten katoaisivat nopeasti.",
        en:
          "The aim is to leave room for gestures, glances and small moments that might otherwise disappear quickly.",
      },

      caption: {
        fi: "Kuvaaja · Photography Studio",
        en: "Photographer · Photography Studio",
      },

      alt: {
        fi: "Valokuvaaja",
        en: "Photographer",
      },
    },

    philosophy: {
      eyebrow: {
        fi: "Kuvausfilosofia",
        en: "Photography philosophy",
      },

      title: {
        fi:
          "Täydellisen hetken sijaan etsin hetkeä, joka tuntuu omalta.",
        en:
          "Instead of a perfect moment, I look for one that feels like yours.",
      },

      text: {
        fi:
          "Kuvissa saa näkyä elämä. Kaiken ei tarvitse olla täysin hallittua, symmetristä tai valmiiksi mietittyä. Usein kiinnostavin kuva löytyy juuri siitä pienestä hetkestä suunnitelman vierestä.",
        en:
          "Photographs are allowed to show life. Not everything has to be controlled, symmetrical or planned in advance. Often the most interesting image appears in the small moment just beside the plan.",
      },
    },

    principles: {
      eyebrow: {
        fi: "Työskentelytapa",
        en: "The approach",
      },

      items: [
        {
          id: "01",

          title: {
            fi: "Rauha",
            en: "Calm",
          },

          text: {
            fi:
              "Kuvaustilanteelle annetaan aikaa. Kaikkea ei tarvitse saada aikaan ensimmäisten minuuttien aikana.",
            en:
              "The session is given time. Nothing has to happen perfectly within the first few minutes.",
          },
        },

        {
          id: "02",

          title: {
            fi: "Ohjaus",
            en: "Guidance",
          },

          text: {
            fi:
              "Saat apua silloin kun sitä tarvitaan. Tarkoitus ei kuitenkaan ole pakottaa jokaista hetkeä samaan valmiiseen asentoon.",
            en:
              "Guidance is there whenever it is useful, without forcing every moment into the same predefined pose.",
          },
        },

        {
          id: "03",

          title: {
            fi: "Tunne",
            en: "Feeling",
          },

          text: {
            fi:
              "Kuvan ei tarvitse olla vain kaunis. Sen pitäisi myös palauttaa mieleen jotain siitä, miltä hetkessä tuntui.",
            en:
              "A photograph does not need to be merely beautiful. It should also bring back something of how the moment felt.",
          },
        },
      ],
    },

    statement: {
      eyebrow: {
        fi: "Miksi kuvaan",
        en: "Why photographs matter",
      },

      title: {
        fi:
          "Jotkut hetket ymmärtää vasta myöhemmin.",
        en:
          "Some moments only reveal their meaning later.",
      },

      text: {
        fi:
          "Siksi kuva ei ole vain tallenne siitä, miltä jokin näytti. Parhaimmillaan se on reitti takaisin ihmiseen, paikkaan ja tunteeseen.",
        en:
          "That is why a photograph is more than a record of how something looked. At its best, it becomes a way back to a person, a place and a feeling.",
      },
    },

    cta: {
      eyebrow: {
        fi: "Tutustutaanko?",
        en: "Shall we meet?",
      },

      title: {
        fi:
          "Kerro, mitä haluaisit muistaa.",
        en:
          "Tell me what you would like to remember.",
      },

      text: {
        fi:
          "Jos kuvaustapa tuntuu omalta, kerro ajatuksestasi. Katsotaan yhdessä, millainen kuvaus sopisi siihen.",
        en:
          "If this way of working feels right for you, tell me what you have in mind and we can shape a session around it.",
      },

      button: {
        fi: "Ota yhteyttä",
        en: "Get in touch",
      },
    },
  },
};

export default aboutData;